import { TransactionDetails } from '@/components/transactions-page/transactionDetails-page';
import useRefresh from '@/hooks/use-refresh';
import { Helmet as Head } from 'react-helmet';

const TransactionDetailsPage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Transaction Details</title>
      </Head>
      <TransactionDetails />
    </>
  );
};

export default TransactionDetailsPage;
